const ACTIVE_POLL_INTERVAL_MS = 250
const COLLAPSED_POLL_INTERVAL_MS = 1000

export function getMediaDockPollIntervalMs({
    isPlaying,
    isDocumentVisible,
    isAwaitingHandoff,
    isExpanded,
    isDraggingSeek,
}) {
    if (!isPlaying || !isDocumentVisible) return null
    if (isAwaitingHandoff || isExpanded || isDraggingSeek) return ACTIVE_POLL_INTERVAL_MS
    return COLLAPSED_POLL_INTERVAL_MS
}

export function retainMediaDockProgress(previous, candidate) {
    const currentTime =
        Number.isFinite(candidate?.currentTime) && candidate.currentTime >= 0
            ? candidate.currentTime
            : previous.currentTime
    const duration =
        Number.isFinite(candidate?.duration) && candidate.duration > 0
            ? candidate.duration
            : previous.duration

    if (currentTime === previous.currentTime && duration === previous.duration) return previous
    return { currentTime, duration }
}
